import { TEST } from 'constants/application_constants';

export const identifyUser = (user, account, noIntercom = false) => {
  if (TEST) {
    return;
  }
  if (user !== null) {
    window.Intercom('update', {
        user_id: user.id,
        name: user.display_name,
        company: {
          id: user.account.id,
          name: user.account.name,
          created_at: user.account.created_at,
        },
        email: user.email,
        first_name: user.first_name,
        last_name: user.last_name,
        display_name: user.display_name,
        created_at: user.created_at,
        language_override: user.locale,
        account_name: user.account.name,
        user_hash: user.intercom_hash,
        hideDefaultLauncher: noIntercom || user.hide_intercom_chat,
      });
    
    /*analytics.identify(user.id, camelize(user.segment_traits), {
      Intercom: {
        user_hash: user.intercom_hash,
        language_override: user.locale,
        hideDefaultLauncher: noIntercom || user.hide_intercom_chat,
      },
    });*/
    if (account !== null) {
      //analytics.group(account.segment_id, camelize(account.segment_traits));
    }
  }
};

